module.exports = __webpack_public_path__ + "static/media/60.5b57b095.jpg";